import { Component, OnInit } from "@angular/core";
import { Produto } from "../../model/produto";
import { ProdutoServico } from "../../servicos/produto/produto.servico";
import { Router } from "@angular/router";

@Component({
  selector: "pesquisa-produto",
  templateUrl: "./pesquisa.produto.component.html",
  styleUrls: ["./pesquisa.produto.component.css"]
})

export class PesquisaProdutoComponent implements OnInit {

  public produtos: Produto[];

  ngOnInit(): void {

  }

  constructor(private produtoServico: ProdutoServico, private router: Router) {
    this.produtoServico.obterTodosProdutos()
      .subscribe(
        produtos => {
          this.produtos = produtos;
        },
        err => {
          console.log(err.error);
        }
      )
  }

  public adicionarProduto() {
    sessionStorage.setItem('produtoSession', '');
    this.router.navigate(['/cadastrar-produto']);
  }

  public excluirProduto(produto: Produto) {
    var retorno = confirm("Deseja realmente excluir o produto selecionado?");
    if (retorno == true) {
      this.produtoServico.excluir(produto).subscribe(
        produtos => {
          this.produtos = produtos;
        },
        err => {
          console.log(err.error);
        }
      );
    }
  }

  public editarProduto(produto: Produto) {
    sessionStorage.setItem('produtoSession', JSON.stringify(produto));
    this.router.navigate(['/cadastrar-produto']);
  }
}
